import styled from 'styled-components';

export const ScrollWrapper = styled.div`
	overflow-y: auto;
	height: 100%;
	width: 100%;
`;

export const ContentContainer = styled.div`
	padding: 56px 64px;
	max-width: 720px;
	margin: 0 auto;
`;

export const GuidelineHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 48px;
`;

export const GuidelineTitleInput = styled.input`
	font-size: 32px;
	font-weight: 600;
	margin: 0;
	color: ${({ theme }) => theme.gray[1000]};
	background: transparent;
	border: none;
	outline: none;
	width: 100%;
	padding: 0;
	font-family: inherit;
	flex: 1;
	min-width: 0;

	&:read-only {
		pointer-events: none;
	}
`;

export const DeleteButton = styled.button`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[600]};
	background: transparent;
	padding: 4px 12px;
	border-radius: 12px;
	border: 1px solid transparent;
	font-weight: 500;
	white-space: nowrap;
	transition: all 0.15s ease;

	&:hover {
		background: ${({ theme }) => theme.red[200]};
		color: ${({ theme }) => theme.red[700]};
		border-color: ${({ theme }) => theme.red[500]};
	}
`;
